import PropTypes from 'prop-types';
import useCreatePermissionRequest from '../../../utils/apis/useCreatePermissionRequest';
import { LoadingButton, Toast, useToast } from '@zillow/constellation';

export default function RequestPermissionButton({ userManagementCompanyId }) {
  const { enqueueToast } = useToast();
  const {
    isPending,
    isSuccess,
    mutate: createPermissionRequest,
  } = useCreatePermissionRequest(userManagementCompanyId, {
    onSuccess() {
      enqueueToast(<Toast appearance="success" body="We've sent a permissions request to your application manager" />);
    },
    onError() {
      enqueueToast(<Toast appearance="error" body="An error has occurred. Please try again." />);
    },
  });
  return (
    <LoadingButton
      buttonType="primary"
      id="request-permission-button"
      loading={isPending}
      disabled={isSuccess}
      onClick={createPermissionRequest}
    >
      {isSuccess ? 'Request sent' : 'Request permission'}
    </LoadingButton>
  );
}

RequestPermissionButton.propTypes = {
  userManagementCompanyId: PropTypes.string.isRequired,
};
